import { html, css } from 'lit-element';
import { BaseElement } from './BaseElement';
import { API, EVENT_TYPES } from '../API';
import { DIALOG_TYPE_ERROR } from './ModalDialog';
import { PhysicianPortalSurveyQuestions as _PhysicianPortalSurveyQuestions } from '../PhysicianPortalSurveyQuestions';
import * as GUID from '../GUID';

import './SurveyQuestion';

const _questions = Symbol();
const _api = Symbol();
const _statusHandler = Symbol();

class SurveyQuestions extends BaseElement {
	constructor() {
		super();

		this[_statusHandler] = () => {
			if(this.api.loggedIn && !this.questions && this.api.isPhysician)
				this.getSurveyQuestions();
			else if(!this.api.loggedIn)
				this.questions = null;
			this.requestUpdate();
		};
	}
	static get styles() {
		return [
			...BaseElement.styles,
			css`
				:host {
					display: block;
				}
				legend {
					padding: 0 0.5em;
					border-bottom: none;
					font-weight: bold;
				}
			`
		];
	}
	get api() {
		return this[_api];
	}
	set api(v) {
		if(v !== null && !(v instanceof API))
			throw new TypeError('api must be an instance of API.');
		this[_api] = v;
	}
	get questions() {
		return this[_questions];
	}
	set questions(v) {
		if(v !== null && !(v instanceof _PhysicianPortalSurveyQuestions))
			throw new TypeError('types must be an instance of PhysicianPortalSurveyQuestions.');
		this[_questions] = v;
		this.requestUpdate();
	}
	async getSurveyQuestions() {
		const id = GUID.newGUID();
		try {
			this.emit('show-busy', id);
			if(!this.api)
				throw new Error('no api set.');
			this.questions = await this.api.surveyQuestions();
			const ids = await this.api.doctorPhysicianPortalSurveyQuestionIds();
			[...this.shadowRoot.querySelectorAll('pp-survey-question')].forEach(v => {
				v.checked = ids.indexOf(v.question.physicianPortalSurveyQuestionId) >= 0;
			});
			this.emit('hide-busy', id);
		}
		catch(err) {
			this.emit('hide-busy', id);
			this.emit('show-dialog', {
				title: 'Survey Questions',
				message: err.message,
				type: DIALOG_TYPE_ERROR
			});
		}
	}

	async checkHandler(e) {
		try {
			const { question, checked } = e.target;

			if(checked)
				await this.api.addSurveyQuestion(question.physicianPortalSurveyQuestionId);
			else
				await this.api.removeSurveyQuestion(question.physicianPortalSurveyQuestionId);
		}
		catch(err) {
			this.emit('show-dialog', {
				title: 'Survey Question Error',
				message: err.message,
				type: DIALOG_TYPE_ERROR
			});
		}
	}
	connectedCallback() {
		super.connectedCallback();

		this.emit('get-api', { callback: api => this.api = api });
		this.api.on(EVENT_TYPES.EVENT_TYPE_LOGIN_STATUS, this[_statusHandler]);
		
		
		if(this.api.loggedIn && this.api.isPhysician)
			this.getSurveyQuestions();
	}
	disconnectedCallback() {
		super.disconnectedCallback();

		this.api.off(null, this[_statusHandler]);
		this.api = null;
	}
	render() {
		return html`
			<fieldset>
				<legend>Survey Questions</legend>
				<p class="info">
					<i class="icon fas fa-info-circle"></i>
					Select the survey questions you would like to ask your patients.
				</p>
				${this.questions ? [...this.questions].map(v => html`
					<pp-survey-question @check="${(e) => this.checkHandler(e)}" .question="${v}"></pp-survey-question>
				`) : ''}
			</fieldset>
		`;
	}
}

customElements.define('pp-survey-questions', SurveyQuestions);